@if (loading()) {
<lib-frontend-spinner text="Daten werden geladen" />
} @else {
<div class="card">
  <div class="card-body text-center">
    @if (success() === false) {
    <h3>Zahlung bei Provoider abgebrochen oder es gabe einen Problem.</h3>
    <a
      href="?channel={{ parameterService.queryParams.channel_id }}&&payment={{
        parameterService.queryParams.payment_id
      }}"
      >zurück zur Zahlungsübersicht</a
    >
    }
  </div>
</div>
}
